import React from "react";
import { Link } from "react-router-dom";

import {
  Card,
  CardContent,
  Grid,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { orange } from "@material-ui/core/colors";

import { SelectField, TextField } from "react-admin";

import { ExceptionIcon } from "../../../components/common/iconography";
import { isAuthorized } from "../../../utils/appUtils";
import { AclType, CarrierType, InboundStates } from "../../../utils/constants";
import { CarrierInboundStatuses } from "../carrierStatusLabels";
import { InboundStateIcon } from "../../../managerApp/resources/inboundShipments/InboundStateIcon";
import { PhotoViewer } from "../../../components/common/PhotoViewer";

const useAsideStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("sm")]: {
      width: "18em",
      minWidth: "18em",
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(0.5),
      overflow: "initial",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  status: {
    marginTop: theme.spacing(0.3),
  },
}));

export const InboundAside = ({ backPath, record, exceptions, ...props }) => {
  const classes = useAsideStyles();
  const linkBackPath = backPath
    ? [...backPath, props.location.pathname]
    : [props.location.pathname];

  if (!record) return null;
  return (
    <Card className={classes.root}>
      <CardContent>
        <Grid container direction="column" spacing={1} fullWidth>
          <Grid item xs={12}>
            <Typography variant="overline" color="textSecondary">
              Status
            </Typography>
            <Grid container direction="row">
              <Grid item xs={2}>
                <InboundStateIcon record={record} />
              </Grid>
              <Grid item xs={10} className={classes.status}>
                <SelectField
                  source="status"
                  choices={CarrierInboundStatuses}
                  record={record}
                />
                ,&nbsp;
                <SelectField
                  source="state"
                  choices={InboundStates}
                  record={record}
                />
              </Grid>
            </Grid>
            {exceptions.hasException && (
              <Grid item xs={12}>
                <Typography variant="overline" color="textSecondary">
                  Exceptions
                </Typography>
              </Grid>
            )}
            {exceptions.hasException && exceptions.unsafeShipment && (
              <Grid container direction="row">
                <Grid item xs={2}>
                  <Tooltip
                    title={
                      exceptions.unsafeShipmentNote
                        ? exceptions.unsafeShipmentNote
                        : "Unsafe Shipment"
                    }
                    placement="left"
                    arrow
                  >
                    <ExceptionIcon style={{ color: orange[600] }} />
                  </Tooltip>
                </Grid>
                <Grid item xs={10} className={classes.status}>
                  <Typography variant="body2">Unsafe Shipment</Typography>
                </Grid>
              </Grid>
            )}
            {exceptions.hasException && exceptions.brokenSeal && (
              <Grid container direction="row">
                <Grid item xs={2}>
                  <Tooltip
                    title={
                      exceptions.brokenSealNote
                        ? exceptions.brokenSealNote
                        : "Broken Seal"
                    }
                    placement="left"
                    arrow
                  >
                    <ExceptionIcon style={{ color: orange[600] }} />
                  </Tooltip>
                </Grid>
                <Grid item xs={10} className={classes.status}>
                  <Typography variant="body2">Broken Seal</Typography>
                </Grid>
              </Grid>
            )}
            {exceptions.hasException && exceptions.otherException && (
              <Grid container direction="row">
                <Grid item xs={2}>
                  <Tooltip
                    title={
                      exceptions.otherExceptionNote
                        ? exceptions.otherExceptionNote
                        : "Other Exception"
                    }
                    placement="left"
                    arrow
                  >
                    <ExceptionIcon style={{ color: orange[600] }} />
                  </Tooltip>
                </Grid>
                <Grid item xs={10} className={classes.status}>
                  <Typography variant="body2">Other Exception</Typography>
                </Grid>
              </Grid>
            )}
          </Grid>
          <Grid item xs={12}>
            <Typography variant="overline" color="textSecondary">
              PO Number
            </Typography>
            <br />
            <TextField source="poNumber" record={record} />
          </Grid>
          {record.railCarNumber && (
            <Grid item xs={12}>
              <Typography variant="overline" color="textSecondary">
                {record.carrierType === CarrierType.RAIL
                  ? "Railcar Number"
                  : "Trailer Number"}
              </Typography>
              <br />
              <TextField source="railCarNumber" record={record} />
            </Grid>
          )}
          <Grid item xs={12}>
            <Typography variant="overline" color="textSecondary">
              Lot Number
            </Typography>
            <br />
            <TextField source="lotNumber" record={record} />
          </Grid>
          {record.invoice && isAuthorized(AclType.INVOICES) && (
            <Grid item xs={12}>
              <Typography variant="overline" color="textSecondary">
                Invoice
              </Typography>
              <br />
              <Link
                to={{
                  pathname: `/invoices/${record.invoiceId}`,
                  state: { backPath: linkBackPath },
                }}
              >
                <Typography variant="body2" color="primary">
                  {record.invoice.invoiceNumber} : $
                  {record.invoice.total.toLocaleString(undefined, {
                    style: "currency",
                    currency: "USD",
                  })}
                </Typography>
              </Link>
            </Grid>
          )}
          <PhotoViewer photos={record.photos?.items} />
        </Grid>
      </CardContent>
    </Card>
  );
};
